
import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import "react-table-6/react-table.css";
import $ from 'jquery';
import 'react-widgets/dist/css/react-widgets.css';
import Leads from './Leads';
import MyLeads from './MyLeads';


class LeadsSettings extends Component {
  constructor() {
    super();

    this.state = {
       showOnlyMyLeads: false
    }
   
  }

  componentDidMount() {

     var userRole = localStorage.getItem("PROJECT_ROLE");
     if( userRole === "PROJECT_SUPPORT_USER") {
          this.setState({ showOnlyMyLeads: true});
     }
     
    (function () {
      var currentPath = window.location.href;
      var currentPath = window.location.href;
      var path = window.origin + "/sales-desk/projectmgmt/settings/leads";
      var path1 = window.origin + "/sales-desk/projectmgmt/settings/leads/";
      if (currentPath === path || currentPath === path1) {
          $("#my-leads").addClass('active');
      } else if (currentPath.includes("/projectmgmt/settings/leads/all-leads")) {
          $("#all-leads").addClass('active');
      }else {
          $("#" + localStorage.getItem("last-leads-data-tab")).addClass('active')
      }
      $("#my-leads,#all-leads")
          .on("click", function () {
              $("#my-leads,#all-leads")
                  .removeClass('active');
              localStorage.setItem("last-leads-data-tab", $(this)[0].id);
              $(this).addClass('active')
          })
  })();
  }

  
  render() {


    
    return (

      <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

              <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
              <title> Dheeyantra | Clusters Details</title>
              {/* Font Awesome Icons */}
              <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
              {/* IonIcons */}
              <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
              <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
              {/* Theme style */}
              <link rel="stylesheet" href="assets/css/adminlte.css" />
              <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
              <link rel="stylesheet" href="assets/css/custom-style.css" />
              <link rel="stylesheet" href="assets/css/styles.css" />
              <link rel="stylesheet" href="assets/css/custom-style.css" />
             

              <div className="container-fluid" >
                  {/* Nav tabs */}
                  <div className="border-botto"></div>
                  <div className="tab-class">
                      <ul className="nav nav-tabs border-botto navCluster">
                          <Link className="nav-item" data-toggle="tab"
                              to="/projectmgmt/settings/leads" style={{ textDecoration: 'none' }}>
                              <li className="nav-link" id="my-leads" style={{ marginRight: '15px' }}>
                              My Leads
                              </li></Link>
                          <Link className="nav-item" data-toggle="tab"
                              to="/projectmgmt/settings/leads/all-leads" style={{ textDecoration: 'none' }}>
                              <li className="nav-link" id="all-leads" style={{ marginRight: '15px', 
                               display: this.state.showOnlyMyLeads ? "none" : "block"
                            }}>
                                 All Leads
                              </li></Link>
                         
                         
                      </ul>
                  </div>
              </div>
          </div>
          <Switch>
              <Route exact path="/projectmgmt/settings/leads" component={MyLeads}></Route>
              <Route path="/projectmgmt/settings/leads/all-leads" component={Leads}></Route>
              
          </Switch>
      </div>

  );

  }
}

export default LeadsSettings;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/LeadsSettings.js